import { connect } from 'react-redux'
import { compose } from 'redux'
import { deleteWeekProgramFlyerDate, updateWeekProgramFlyerDate } from '../../../actions'
import toJS from '../../../hoc/toJS'
import PrintWeekProgramFlyerDateItem from '../present/PrintWeekProgramFlyerDateItem'

const mapDispatchToProps = (dispatch, ownProps) => ({
    printToolDeleteDatePeriod: (itemId) => {
        dispatch(deleteWeekProgramFlyerDate(itemId))
    },
    printToolUpdateDatePeriod: (item) => {
        dispatch(updateWeekProgramFlyerDate(item))
    }
})

const PrintWeekProgramFlyerDateItemContainer = ({ printToolUpdateDatePeriod, printToolDeleteDatePeriod, currentPeriodItem }) => {
    return <PrintWeekProgramFlyerDateItem 
        printToolUpdateDatePeriod={printToolUpdateDatePeriod}
        printToolDeleteDatePeriod={printToolDeleteDatePeriod}
        currentPeriodItem={currentPeriodItem}
    />
}

export default compose(
    connect(null, mapDispatchToProps),
    toJS()
)(PrintWeekProgramFlyerDateItemContainer)